module.exports = "/images/logo-text.png?caa22b4a109271fc8740edf5a2449b23";